import React from 'react';

import { Container } from './EmptyContentBox.styles';

export interface EmptyContentBoxProps {
  isLoading?: boolean;
  loadingLabel?: string;
  noDataLabel?: string;
}

function EmptyContentBox(props: EmptyContentBoxProps) {
  const {
    isLoading,
    loadingLabel = 'Loading',
    noDataLabel = 'No data',
  } = props;

  return <Container>{isLoading ? loadingLabel : noDataLabel}</Container>;
}

export default EmptyContentBox;
